import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import RegisterHook from "../../hook/auth/RegisterHook";
import { ToastContainer } from "react-toastify";
import { useSelector } from "react-redux";
import LoadingSpinner from "../../Components/Utilities/LoadingSpinner";
import { useTranslation } from "react-i18next";
import cookies from "js-cookie";

const RegisterPage = () => {
  const { t } = useTranslation();
  
  const [
    firstname,
    lastname,
    mobile,
    email,
    password,
    confirmPassword,
    acceptTerms,
    loading,
    onChangeFirstname,
    onChangeLastname,
    onChangeMobile,
    onChangeEmail,
    onChangePassword,
    onChangeConfirmPassword,
    onChangeAcceptTerms,
    onSubmit,
  ] = RegisterHook();
  const settingsRes = useSelector((state) => state.settingsReducers.settings);
  console.log('loading',loading);
  return (
    <Container style={{ minHeight: "670px" }}>
      <Row className="py-5 d-flex justify-content-center hieght-search">
        <Col sm="12" className="d-flex flex-column ">
<label className="mx-auto title-login">{t("create new account")}</label>
          <input
            value={firstname}
            onChange={onChangeFirstname}
            placeholder={t("first name")}
            type="text"
            className="user-input my-2 text-center mx-auto"
          />
          <input
            value={lastname}
            onChange={onChangeLastname}
            placeholder={t("last name")}
            type="text"
            className="user-input my-2 text-center mx-auto"
          />

          <input
            value={email}
            onChange={onChangeEmail}
            placeholder={t("email")}
            type="email"
            className="user-input my-2 text-center mx-auto"
          />
          <input
            value={mobile}
            onChange={onChangeMobile}
            placeholder={t("phone")}
            type="phone"
            className="user-input my-2 text-center mx-auto"
          />

          <input
            value={password}
            onChange={onChangePassword}
            placeholder={t("password")}
            type="password"
            className="user-input my-2 text-center mx-auto"
          />
          <input
            value={confirmPassword}
            onChange={onChangeConfirmPassword}
            placeholder={t("confirm password")}
            type="password"
            className="user-input my-2 text-center mx-auto"
          />

          <div className="my-2 text-center mx-auto">
            <input
              type="checkbox"
              checked={acceptTerms}
              onChange={onChangeAcceptTerms}
            />
            <Link
              to={`/terms/${1}`}
              style={{ textDecoration: "underline", cursor: "pointer" }}
            >
              {t("agree terms")}
            </Link>
          </div>

          <button
            onClick={onSubmit}
            className="btn-login mx-auto mt-4"
            style={{ backgroundColor: settingsRes?.data?.primaryColor }}
            disabled={!loading}
          >
            {
              !loading ? <LoadingSpinner /> : t("create account")
            }
            
          </button>
          <label className="mx-auto my-4">
            {t("already have account")}
            <Link to="/login" style={{ textDecoration: "none" }}>
              <span style={{ cursor: "pointer" }} className="text-danger">
                {t("click here")}
              </span>
            </Link>
          </label>
        </Col>
      </Row>
      <ToastContainer />
    </Container>
  );
};

export default RegisterPage;
